import { Modal as AntdModal } from 'antd';
import { Complication } from '../../dto/Complication.dto';
import { ComplicationsForm } from '../Forms/Complications/ComplicationsForm';
import { useCreateComplication, useUpdateComplication } from '../../services/api/complications';

interface ComplicationModalProps {
  setIsOpen: (value: boolean) => void;
  isOpen: boolean;
  complication?: Complication;
}

export function ComplicationModal(props: ComplicationModalProps) {
  const { isOpen, setIsOpen, complication } = props;
  const isEdit = !!complication?.id;
  const title = isEdit ? 'Edit Complication' : 'Add Complication';

  const { mutate: updateComplication } = useUpdateComplication();
  const { mutate: createComplication } = useCreateComplication()

  return (
    <>
      {isOpen && (
        <AntdModal
          destroyOnClose
          title={title}
          open={isOpen}
          footer={null}
          onCancel={onCancel}
        >
          <ComplicationsForm
            complication={complication}
            isEdit={isEdit}
            onFinish={onFinish}
          />
        </AntdModal>
      )}
    </>
  );

  function onCancel() {
    setIsOpen(false);
  }

  async function onFinish(values: any) {
    if (complication) {
      await updateComplication({ id: complication.id, data: values });
    } else {
      await createComplication(values)
    }
    setIsOpen(false);
  }
}
